const rootSelector = '.c-hero_slider';

window.modal_open = false;

function init() {
  const modal_selectors = document.querySelectorAll(rootSelector + '__modal_selector');
  const modals = document.querySelectorAll(rootSelector + '__modal');
  const modal_exits = document.querySelectorAll(rootSelector + '__close');

  if (!modal_selectors.length) {
    return;
  }

  Array.from(modal_selectors).forEach((modal_selector) => {

    modal_selector.addEventListener('click', (e) => {
      open_modal(e);
    });

  });

  Array.from(modals).forEach((modal) => {

    modal.addEventListener('click', (e) => {
      close_modal(e);
    });

  });

  Array.from(modal_exits).forEach((modal_exit) => {

    modal_exit.addEventListener('click', (e) => {
      close_all_modals();
    });

  });

}

function open_modal(e) {

  const modal_id = e.target.closest(rootSelector + '__modal_selector').dataset.modal;
  const modal = document.querySelector("#" + modal_id);
  modal.classList.add('active');
  modal_open = true;

}

function close_modal(e) {

  if(e.target.classList.contains("c-hero_slider__modal")) {

    const modals = document.querySelectorAll(rootSelector + '__modal');
    Array.from(modals).forEach((modal) => {
      modal.classList.remove('active');
    });
    modal_open = false;

  }

}

function close_all_modals() {

  const iframes = document.querySelectorAll('iframe');

  const modals = document.querySelectorAll(rootSelector + '__modal');
  Array.from(modals).forEach((modal) => {
    modal.classList.remove('active');
  });
  modal_open = false;

  Array.from(iframes).forEach((iframe) => {
    var player = new Vimeo.Player(iframe);

    console.log(player);

    player.pause().then(function() {
    // the video was paused
    }).catch(function(error) {
      switch (error.name) {
        case 'PasswordError':
          break;
        case 'PrivacyError':
          break;
        default:
          break;
      }
    });
  });

}

export default init;
